import { useFirebase } from 'react-redux-firebase';
import { FlagKey, getConfigValue } from '../firebase/remoteConfig';

export function useConfigFlag(flag: FlagKey) {
	const firebase = useFirebase();
	return getConfigValue(firebase as any, flag);
}
